export default {"src":"/_next/static/media/safari-pinned-tab.63b9afb8.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};